<script setup>
import XlButton from '../xl/XlButton.vue';
import XlCard from '../xl/XlCard.vue';
import XlStatusIcon from '../xl/XlStatusIcon.vue';
import XlTooltip from '../xl/XlTooltip.vue';
import { TERM_TIPS } from '../../helpers/termTips';

const props = defineProps({
  count: { type: Number, default: 0 },
});

const emit = defineEmits(['show']);
</script>

<template>
  <XlCard v-if="props.count" padded tone="error" class="unassigned-banner" data-testid="unassigned-banner">
    <XlStatusIcon tone="error">!</XlStatusIcon>
    <div class="unassigned-banner__text">
      <!-- "broker" is the term being used, so it is the term explained. -->
      <XlTooltip :text="TERM_TIPS.Broker" placement="bottom" underline>
        <b>
          {{ props.count }} {{ props.count === 1 ? 'policyholder has' : 'policyholders have' }} no broker
        </b>
      </XlTooltip>
      <span>
        They see no contact in the portal, and nobody is watching their renewal.
        New registrations aren't assigned automatically.
      </span>
    </div>
    <XlButton @click="emit('show')">Show them</XlButton>
  </XlCard>
</template>

<style scoped>
.unassigned-banner {
  display: flex;
  gap: 13px;
  align-items: center;
  flex-wrap: wrap;
}

.unassigned-banner__text {
  flex: 1;
  min-width: 200px;
  font-family: var(--xl-font-family);
}

.unassigned-banner__text b {
  display: block;
  font-size: var(--xl-type-title-small-size);
  color: var(--xl-color-primary-text);
}

.unassigned-banner__text span {
  font-size: var(--xl-type-body-medium-size);
  color: var(--xl-color-secondary-text);
}
</style>
